import { defineMessages } from 'react-intl';

export const ScopeName = 'Pages.ManageConciergeSolicitationPage';

const Scope = defineMessages({
  title: {
    id: `${ScopeName}.title`,
    defaultMessage: 'Página de Gerenciamento de Solicitação de Concierge',
  },
  msgErrorModule: {
    id: `${ScopeName}.msgErrorModule`,
    defaultMessage: 'Não foi possível carregar o módulo federado',
  },
});

export default Scope;
